!function(){
  // ==== Configuration ====
  const CONFIG = {
    TEST_ID: "SB-096DM",              // Unique test ID (used for logging & style ID)
    TEST_NAME: "Sticky Add to Cart: One-Time vs Subscription Options",         // Descriptive test name
    BUCKET: "Variation 1",             // A/B variant (e.g., A, B, CONTROL)

    STYLES: {
      FONT: "font-weight: 900; font-size: 11px",
      SUCCESS: `background:rgb(${Math.floor(Math.random() * (254 - 50 + 1)) + 50}, 83, 65); color: #FFFFFF`,
      WARNING: "background:rgb(251, 200, 174); color: #F62817"
    },

    SELECTORS: {
      BODY: "body",                 // Element to wait for before bootstrapping test
      SUBSCRIPTION_CONTENTS: ".subscription-contents",
      SUBSCRIPTION_CHECKED: ".subscription-contents input:checked",
      FREQUENCY_SELECTOR: "select.frequency-selector",
      /** Skio: custom element + shadow, or fieldset.skio-plan-picker (light DOM, same inner markup) */
      SKIO_HOST: "skio-plan-picker",
      SKIO_FIELDSET: "fieldset.skio-plan-picker",
      SKIO_SHADOW_SELECTED: ".group-container.group-container--selected input",
      SKIO_SHADOW_GROUPS: ".group-container",
      SKIO_SHADOW_FREQUENCY: ".selling-plan-dropdown",
    },

    CHECK_URL: "https://cdn.shopify.com/s/files/1/0866/7664/files/green-check.svg",
    CROSS_URL: "https://cdn.shopify.com/s/files/1/0866/7664/files/cross.svg",

    ARROW: `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
      <path d="M11.91 -4.33072e-07L12.97 1.061L7.193 6.84C7.10043 6.93315 6.99036 7.00708 6.86911 7.05753C6.74786 7.10798 6.61783 7.13395 6.4865 7.13395C6.35517 7.13395 6.22514 7.10798 6.10389 7.05753C5.98264 7.00708 5.87257 6.93315 5.78 6.84L2.65457e-07 1.061L1.06 0.00099902L6.485 5.425L11.91 -4.33072e-07Z" fill="#111314"/>
    </svg>`,

    CLOSE: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_219_105)">
        <path d="M5.98966 5.98959L18.0105 18.0104M18.0105 5.98959L5.98966 18.0104" stroke="#111314" stroke-linecap="round"/>
      </g>
      <defs>
        <clipPath id="clip0_219_105">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>`,
    
    VP: [
      'Save 10% on every order',
      'Free Shipping',
      'Cancel or pause anytime'
    ],

    TIMEOUT: 30000,                // Max wait time for selectors/variables
    INTERVAL: 25,                  // Interval for polling checks
    OBSERVER: true                 // Toggle MutationObserver logic
  };

  // ==== Styled Console Logging ====
  const STYLE = CONFIG.STYLES;
  const log = {
    success: (msg) => console.log(`%c ${msg} `, `${STYLE.SUCCESS};${STYLE.FONT}`),
    warning: (msg) => console.warn(`%c ${msg} `, `${STYLE.WARNING};${STYLE.FONT}`),

    start() {
      this.success(`==== ${CONFIG.TEST_ID} START ====`);
      this.success(`ID: ${CONFIG.TEST_ID} \n NAME: ${CONFIG.TEST_NAME} \n BUCKET: ${CONFIG.BUCKET} `);
    },
    end() {
      this.success(`==== ${CONFIG.TEST_ID} END ====`);
    },
    fail(error) {
      this.warning(`%c ERROR => ${error.message}`, `${STYLE.WARNING};${STYLE.FONT}`);
      this.warning(`%c ${CONFIG.TEST_ID} x x x x x Failed`, `${STYLE.WARNING};${STYLE.FONT}`);
    }
  };

  // ==== Test bucket log ====
  console.log(`%c [${CONFIG.TEST_ID}] Bucketed into: ${CONFIG.BUCKET}`, `${STYLE.SUCCESS};${STYLE.FONT}`);

  // ==== Utility Functions ====
  const utils = {
    q: (s, e = document) => e.querySelector(s),
    qs: (s, e = document) => e.querySelectorAll(s),
    eh: (el, pos, html) => el.insertAdjacentHTML(pos, html),
    ie: (el, pos, node) => el.insertAdjacentElement(pos, node),

    wait(selector, cb, {
      multiple = false,
      isVariable = false,
      minCount = 1,
      timeout = CONFIG.TIMEOUT,
      interval = CONFIG.INTERVAL,
      el = document
    } = {}) {
      const start = Date.now();
      (function check() {
        const result = isVariable
          ? window[selector]
          : (multiple ? utils.qs(selector, el) : utils.q(selector, el));

        const isReady = isVariable
          ? typeof result !== 'undefined'
          : (multiple ? result.length >= minCount : !!result);

        if (isReady) cb(result);
        else if (Date.now() - start < timeout) setTimeout(check, interval);
      })();
    },

    debounce(fn, delay) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), delay);
      };
    },

    isMobile() {
      return window.matchMedia("(max-width: 767px)").matches;
    },

    injectStyle(id, css) {
      if (document.getElementById(id)) return;
      const style = document.createElement("style");
      style.id = id;
      style.setAttribute("type","text/css");
      style.textContent = css;
      document.head.appendChild(style);
    },

    // Check if element (el) is in viewport (any part visible)
    isInViewport(el) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;
      return (
        rect.top < windowHeight &&
        rect.bottom > 0 &&
        rect.left < windowWidth &&
        rect.right > 0
      );
    },

    // outerHTML clones often lose selected state; sync every sticky copy from main
    syncStickyFrequencySelects(stickyDetails, mainSelect) {
      if (!stickyDetails || !mainSelect) return;
      const value = mainSelect.value;
      const idx = mainSelect.selectedIndex;
      stickyDetails.querySelectorAll('.r-sf-select select').forEach((stickySel) => {
        stickySel.removeAttribute('id');
        stickySel.value = value;
        if (stickySel.value !== value && idx >= 0 && idx < stickySel.options.length) {
          stickySel.selectedIndex = idx;
        }
      });
    },

    /** Size+flavor, flavor-only (no size UI), or size-only */
    matchVariantForSticky(variants, sizeValue, flavorValue) {
      const list = variants || [];
      if (!list.length) return null;
      const sz = String(sizeValue ?? '').trim();
      const fl = String(flavorValue ?? '').trim();
      if (sz && fl) {
        const m = list.find(
          (v) =>
            String(v.option1 || '').trim() === sz &&
            String(v.option2 || '').trim() === fl
        );
        return m || list[0];
      }
      if (fl && !sz) {
        let m = list.find((v) => String(v.option2 || '').trim() === fl);
        if (m) return m;
        m = list.find((v) => {
          const o1 = String(v.option1 || '').trim();
          const o2 = String(v.option2 || '').trim();
          return o1 === fl && !o2;
        });
        if (m) return m;
        m = list.find((v) => String(v.option1 || '').trim() === fl);
        return m || list[0];
      }
      if (sz && !fl) {
        const m =
          list.find((v) => String(v.option1 || '').trim() === sz) ||
          list.find((v) => String(v.option2 || '').trim() === sz);
        return m || list[0];
      }
      return list[0];
    },

    /**
     * Update the sticky bar's product image to match the selected variant.
     * Uses variant.featured_image.src from the Shopify product JSON.
     * .sb-sticky-atc__image is a <div> wrapper — the real <img> is inside it.
     * URLs use Shopify's ?width= param format, not the _160x suffix format.
     * If the variant has no dedicated image, leaves the existing image unchanged.
     */
    updateStickyImage(variant) {
      // The wrapper is a <div>; we need the <img> inside it
      const wrapper = utils.q('.sb-sticky-atc__image');
      const img = wrapper && wrapper.querySelector('img');
      if (!img || !variant) return;
      const src = variant.featured_image && variant.featured_image.src;
      if (!src) return;
      // Strip any existing ?width= param then set our own at 136 (matches srcset)
      const base = src.replace(/[?&]width=\d+/, '').replace(/\?$/, '');
      const sized = base + (base.includes('?') ? '&' : '?') + 'width=136';
      if (img.src === sized || img.getAttribute('src') === sized) return; // no-op
      img.src = sized;
      img.srcset = sized + ' 136w';
    },

    // Skio: shadow on <skio-plan-picker> OR <fieldset class="skio-plan-picker"> (light); else subscription-contents
    getSubscriptionContext() {
      const resolveSkioPlanRoot = () => {
        const skioHost = utils.q(CONFIG.SELECTORS.SKIO_HOST);
        const shadow = skioHost && skioHost.shadowRoot;
        if (shadow) {
          const groups = shadow.querySelectorAll(CONFIG.SELECTORS.SKIO_SHADOW_GROUPS);
          const type = utils.q(CONFIG.SELECTORS.SKIO_SHADOW_SELECTED, shadow);
          if (groups.length >= 2 && type) return shadow;
        }
        const fieldset = utils.q(CONFIG.SELECTORS.SKIO_FIELDSET);
        if (fieldset) {
          const groups = fieldset.querySelectorAll(CONFIG.SELECTORS.SKIO_SHADOW_GROUPS);
          const type = utils.q(CONFIG.SELECTORS.SKIO_SHADOW_SELECTED, fieldset);
          if (groups.length >= 2 && type) return fieldset;
        }
        return null;
      };
      const planRoot = resolveSkioPlanRoot();
      if (planRoot) {
        return {
          mode: 'skio',
          shadow: planRoot instanceof ShadowRoot ? planRoot : null,
          getMainFrequencySelect() {
            return utils.q(CONFIG.SELECTORS.SKIO_SHADOW_FREQUENCY, planRoot);
          },
          getOneTime() {
            const inp = utils.q(CONFIG.SELECTORS.SKIO_SHADOW_SELECTED, planRoot);
            return !!(inp && inp.value === 'One time purchase');
          },
          syncStickyChoiceToMain(isOnetime, isSubscription) {
            const grps = Array.from(planRoot.querySelectorAll(CONFIG.SELECTORS.SKIO_SHADOW_GROUPS));
            const targetGroup = grps.find((g) => {
              const inp = g.querySelector('input');
              if (!inp) return false;
              if (isOnetime) return inp.value === 'One time purchase';
              if (isSubscription) return inp.value !== 'One time purchase';
              return false;
            });
            if (!targetGroup) return;
            const input = targetGroup.querySelector('input');
            if (input) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            targetGroup.click();
          }
        };
      }
      const subRoot = utils.q(CONFIG.SELECTORS.SUBSCRIPTION_CONTENTS);
      const typeInput = subRoot && utils.q(CONFIG.SELECTORS.SUBSCRIPTION_CHECKED);
      if (subRoot && typeInput) {
        return {
          mode: 'light',
          shadow: null,
          subRoot,
          getMainFrequencySelect() {
            return utils.q(CONFIG.SELECTORS.FREQUENCY_SELECTOR, subRoot)
              || utils.q(CONFIG.SELECTORS.FREQUENCY_SELECTOR);
          },
          getOneTime() {
            const inp = utils.q(CONFIG.SELECTORS.SUBSCRIPTION_CHECKED);
            return !!(inp && inp.value === 'one-time');
          },
          syncStickyChoiceToMain(isOnetime, isSubscription) {
            const value = isOnetime ? 'one-time' : (isSubscription ? 'subscription' : '');
            if (!value) return;
            const input = subRoot.querySelector(`input[value="${value}"]`);
            if (input && !input.checked) input.click();
          }
        };
      }
      return null;
    }
  };

  // ==== Main Test Logic ====
  const test = {
    init() {
      this.injectCSS();   // Inject test-specific styles
      this.bindStickySync(); // r-sf-item click → main subscription radios; select change sync
      this.bindStickyButtonToMainATC(); // sticky ATC → syncs choice to main form then clicks main ATC
      this.bindResize();  // Re-inject r-sticky-details in correct container on mobile/desktop switch
      this.main();        // Run main test logic
      if (CONFIG.OBSERVER) this.observeMutations(); // Optional DOM observer
    },

    bindStickyButtonToMainATC() {
      if (this._stickyButtonBound) return;
      this._stickyButtonBound = true;
      const syncLoadingFromMain = () => {
        const mainBtn = utils.q('.product-form__submit');
        const stickyBtn = utils.q('.sb-sticky-atc__button');
        if (!mainBtn || !stickyBtn) return;
        const mainHasLoading = mainBtn.classList.contains('loading');
        if (mainHasLoading) stickyBtn.classList.add('loading');
        else stickyBtn.classList.remove('loading');
      };
      const ensureStickyHasSpinner = () => {
        const stickyBtn = utils.q('.sb-sticky-atc__button');
        if (!stickyBtn || stickyBtn.querySelector('.r-sticky-spinner')) return;
        const span = document.createElement('span');
        span.className = 'r-sticky-spinner';
        span.setAttribute('aria-hidden', 'true');
        stickyBtn.insertBefore(span, stickyBtn.firstChild);
      };
      const observeMainLoading = () => {
        const mainBtn = utils.q('.product-form__submit');
        if (!mainBtn || mainBtn._rLoadingObserved) return;
        mainBtn._rLoadingObserved = true;
        const mo = new MutationObserver(syncLoadingFromMain);
        mo.observe(mainBtn, { attributes: true, attributeFilter: ['class'] });
      };
      utils.wait('.product-form__submit', () => {
        observeMainLoading();
      });
      utils.wait('.sb-sticky-atc__button', () => {
        ensureStickyHasSpinner();
        syncLoadingFromMain();
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.sb-sticky-atc__button')) return;
        const ctx = utils.getSubscriptionContext();
        e.preventDefault();
        e.stopPropagation();
        // Sync the sticky choice (one-time or subscription) to the main buy box
        // before clicking, so the main form submits the correct purchase type.
        if (ctx) {
          const isOneTime = ctx.getOneTime();
          ctx.syncStickyChoiceToMain(isOneTime, !isOneTime);
        }
        ensureStickyHasSpinner();
        const mainBtn = utils.q('.product-form__submit');
        if (mainBtn) {
          mainBtn.click();
          [0, 50, 150, 400].forEach((ms) => setTimeout(syncLoadingFromMain, ms));
        }
      }, true);
    },

    bindResize() {
      if (this._resizeBound) return;
      this._resizeBound = true;
      this._wasMobile = utils.isMobile();
      const onResize = utils.debounce(() => {
        const nowMobile = utils.isMobile();
        if (nowMobile === this._wasMobile) return;
        this._wasMobile = nowMobile;
        const sticky = document.querySelector('sb-sticky-add-to-cart');
        const el = sticky?.querySelector('.r-sticky-details');
        if (el) el.remove();
        this._lastStickySize = undefined;
        this.main();
      }, 150);
      window.addEventListener('resize', onResize);
    },

    injectCSS() {
      const css = `
        /* Sticky ATC loading: track main CTA .loading class, show spinner only when main has it */
        .sb-sticky-atc__button {
          position: relative;
          height: 44px;
          padding: 8px 32px 10px;
        }
        .sb-sticky-atc__button .r-sticky-spinner {
          display: none;
          position: absolute;
          left: 50%;
          top: 50%;
          width: 18px;
          height: 18px;
          margin-left: -9px;
          margin-top: -9px;
          border: 2px solid currentColor;
          border-top-color: transparent;
          border-radius: 50%;
          animation: r-sticky-spin 0.6s linear infinite;
          z-index: 2;
        }
        .sb-sticky-atc__button.loading .r-sticky-spinner {
          display: block !important;
        }
        .sb-sticky-atc__button.loading::before {
          content: '';
          position: absolute;
          inset: 0;
          background: inherit;
          border-radius: inherit;
          z-index: 1;
          pointer-events: none;
        }
        @keyframes r-sticky-spin {
          to { transform: rotate(360deg); }
        }

        .r-sticky-prices {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 4px;
        }
        .r-sp-original {
          color: #1B73B3;
          font-size: 16px;
          font-weight: 700;
          line-height: 100%;
        }
        .r-sp-current {
          color: #676767;
          font-size: 14px;
          line-height: 100%;
          text-decoration-line: line-through;
        }

        /* Sticky-only: frequency-selector (light) or selling-plan-dropdown (Skio clone) */
        .r-sticky-details select.frequency-selector,
        .r-sticky-details select.selling-plan-dropdown {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          display: flex;
          align-items: center;
          gap: 5px;
          height: 45px;
          max-width: 134px;
          margin-top: 5px;
          padding: 8px 30px 8px 10px;
          background-color: var(--sb-bg-color, #fff);
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='7' viewBox='0 0 12 7' fill='none'%3E%3Cpath d='M12 0.427268C12 0.33238 11.9625 0.235274 11.8897 0.162453C11.744 0.0168114 11.5057 0.0168114 11.3601 0.162453L6.37514 5.14737L1.46304 0.235274C1.3174 0.089632 1.07907 0.089632 0.933432 0.235274C0.78779 0.380916 0.78779 0.619239 0.933432 0.764881L6.11033 5.94399C6.25598 6.08963 6.4943 6.08963 6.63994 5.94399L11.8897 0.694267C11.9647 0.619239 12 0.524362 12 0.427268Z' fill='%23111314' fill-opacity='0.6'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 10px top 50%;
          background-size: 12px;
          border: 1px solid rgba(103, 103, 103, 0.32);
          border-radius: 2px;
          font-size: 14px;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 400;
          font-style: normal;
          font-size: 14px;
          line-height: 140%;
          letter-spacing: 0;
          color: #000;
          padding: 0 0 0 16px;
          min-height: 32px;
          height: 32px;
          width: auto;
          min-width: 111px;
          margin-top: unset;
        }
        .r-sticky-details select:not(:-internal-list-box):not([multiple]):not([popover]) {
          display: -internal-auto-base(inline-block, inline-flex);
        }
        .r-sticky-details select:not(:-internal-list-box) {
          text-shadow: -internal-auto-base(none, inherit);
          text-transform: -internal-auto-base(none, initial);
          text-rendering: -internal-auto-base(auto, inherit);
          letter-spacing: -internal-auto-base(normal, inherit);
          word-spacing: -internal-auto-base(normal, inherit);
          text-align: -internal-auto-base(start, initial);
          text-indent: -internal-auto-base(0px, initial);
          -webkit-rtl-ordering: -internal-auto-base(logical, inherit);
          cursor: -internal-auto-base(default, inherit);
          color: -internal-auto-base(FieldText, inherit);
          background-color: -internal-auto-base(Field, transparent);
          min-inline-size: -internal-auto-base(auto, calc-size(auto, max(size, 24px)));
          min-block-size: -internal-auto-base(auto, calc-size(auto, max(size, 24px, 1lh)));
          align-items: -internal-auto-base(center, unset);
          user-select: -internal-auto-base(auto, none);
          overflow: visible !important;
          font: -internal-auto-base(-webkit-small-control, inherit);
          white-space: -internal-auto-base(pre, inherit);
          border: 1px solid -internal-auto-base(light-dark(#767676, #858585), currentColor);
          padding-block: -internal-auto-base(0, 0.25em);
          padding-inline: -internal-auto-base(0, 0.5em);
          gap: -internal-auto-base(initial, 0.5em);
          border-radius: -internal-auto-base(0, 0.5em);
        }
        .r-sticky-details select:not(:-internal-list-box):not([multiple]) option {
          padding-block-end: -internal-auto-base(1px, 0);
          display: -internal-auto-base(block, flex);
          padding-inline: -internal-auto-base(2px, 0.5em);
        }
        .r-sticky-details select:not(:-internal-list-box) option {
          min-inline-size: 24px;
          min-block-size: -internal-auto-base(24px, max(24px, 1lh));
          font-weight: -internal-auto-base(normal, inherit);
          align-items: center;
          gap: 0.5em;
        }

        .r-sticky-details {
          margin: 0 auto 0 80px;
          width: 100%;
          max-width: 600px;
        }
        .r-sticky-frequency {
          font-size: 16px;
          font-weight: 500;
          line-height: 100%;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .r-sf-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .r-sf-item {
          display: flex;
        }
        .r-sf-item.r-sf-subscription {
          flex-direction: column;
          gap: 8px;
        }
        .r-sf-save {
          display: inline-flex;
          padding: 3px 5px 6px 5px;
          width: fit-content;
          border-radius: 3px;
          background: #1B73B3;
          color: #FFF;
          line-height: 120%;
        }
        .r-sf-radio {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 16px;
          height: 16px;
          border-radius: 88px;
          border: 1px solid #111314;
        }
        .r-sf-radio-inner {
          width: 10px;
          height: 10px;
          border-radius: 10px;
          background: #111314;
          display: flex;
          align-items: center;
          justify-content
        }
        .r-sf-select {
          display: none;
        }
        .r-sf-item.r-sf-active .r-sf-radio-inner,
        .r-sf-item.r-sf-active .r-sf-select {
          display: block !important;
        }
        .r-sf-header {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
        }
        .r-sf-label {
          line-height: 75%;
          margin-bottom: -2px;
        }
        .r-sf-onetime .r-sf-label {
          margin-bottom: 2px;
        }

        /* Value Prop */
        .r-sticky-value-prop {
          display: flex;
          align-items: center;
          gap: 40px;
          justify-content: space-between;
          width: 100%;
        }
        .r-sticky-value-prop-container {
          display: none;
        }
        .r-sf-item.r-sf-active .r-sticky-value-prop-container {
          display: flex !important;
        }
        /* Desktop: value props below both options; check/cross icon by oneTime */
        @media only screen and (min-width: 768px) {
          .r-sticky-value-prop--desktop {
            display: flex !important;
            align-items: center;
            gap: 40px;
          }
          .r-sf-item.r-sf-subscription > .r-sticky-value-prop-container:not(.r-sticky-value-prop--desktop) {
            display: none !important;
          }
          /* Subscription: show only check, hide cross */
          .r-sticky-value-prop--desktop .r-svp-icon--check {
            display: flex !important;
          }
          .r-sticky-value-prop--desktop .r-svp-icon--cross {
            display: none !important;
          }
          /* One-time: show only cross, hide check */
          .r-sticky-details--onetime .r-sticky-value-prop--desktop .r-svp-icon--check {
            display: none !important;
          }
          .r-sticky-details--onetime .r-sticky-value-prop--desktop .r-svp-icon--cross {
            display: flex !important;
          }
        }
        @media only screen and (max-width: 767px) {
          .r-sticky-value-prop--desktop {
            display: none !important;
          }
        }
        .r-svp-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }
        .r-svp-icon {
          display: flex;
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }
        .r-svp-icon img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform: translateZ(0);
        }
        .r-svp-text {
          color: rgba(17, 19, 20, 0.56);
          font-size: 14px;
          font-weight: 700;
          line-height: 130%;
        }
        @media only screen and (min-width: 768px) {
          /* Desktop styles */
          .sb-sticky-atc__content {
            margin: 10px auto;
          }
          .sb-sticky-atc__details {
            min-width: fit-content;
            gap:6px;
          }
          .sb-sticky-atc__image {
            width: 78px;
            height: 78px;
          }
          h3.sb-sticky-atc__title {
            color: #111314;
            font-size: 18px;
            font-weight: 500;
            line-height: 120%;
          }
          .r-sf-item.r-sf-subscription {
            height: 32px;
            justify-content: center;
          }
        }
        @media only screen and (max-width: 1280px) and (min-width: 768px) {
          .r-sticky-details {
            margin-left: 10px;
          }
          .r-sticky-value-prop {
            gap: 8px;
          }
          .r-svp-text {
            font-size: 12px;
          }
          .r-svp-icon {
            width: 14px;
            height: 14px;
          }
        }
        @media only screen and (max-width: 767px) {
          .sb-sticky-atc__reviews {
            display: none !important;
          }
          .sb-sticky-atc__button {
            padding: 8px 16px 10px;
          }
          sb-sticky-add-to-cart {
            padding-top: 0 !important;
          }
          .sb-sticky-atc__content .r-sticky-details,
          .r-sticky-details.r-sticky-details--mobile {
            width: 100%;
            max-width: none;
          }
          .sb-sticky-atc__content {
            display: flex;
            flex-wrap: wrap;
          }
          .sb-sticky-atc__content .r-sticky-details,
          .sb-sticky-atc__content .r-sticky-details.r-sticky-details--mobile {
            flex-basis: 100%;
          }
          .sb-sticky-atc__title {
            font-size: 12px;
            font-family: 'neue-haas-unica', sans-serif;
            font-weight: 500;
          }

          .r-sticky-prices {
            margin-top: 4px;
          }

          .r-sticky-details {
            margin: 0 auto;
            border-top: 1px solid rgba(17, 19, 20, 0.10);
          }
          .r-sf-free-shipping {
            color: #111314;
            font-size: 12px;
            line-height: 120%;
            opacity: 0.6;
          }
          .r-sticky-selected {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #F8F9FB;
            padding: 8px 16px 12px 16px;
            margin-bottom: 10px;
            border-top: 1px solid rgba(17, 19, 20, 0.10);
            border-bottom: 1px solid rgba(17, 19, 20, 0.10);
          }
          .r-sf-edit {
            color: #111314;
            font-size: 16px;
            line-height: 100%;
          }
          .r-sticky-selected-btn {
            display: flex;
            align-items: center;
            gap: 2px;
            padding-bottom: 2px;
            border-bottom: 1px solid #111314;
          }
          .r-sf-arrow {
            width: 24px;
            height: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.3s ease;
          }
          .r-sticky-details:not(.r-sticky-details--frequency-collapsed) .r-sf-arrow {
            transform: rotate(180deg);
          }
          .r-sticky-frequency {
            padding: 40px 16px 24px 16px;
            position: relative;
            overflow: hidden;
            max-height: 600px;
            opacity: 1;
            transition: max-height 0.35s ease, padding 0.35s ease, opacity 0.25s ease;
            flex-direction: column-reverse;
            gap: 12px;
          }
          .r-sticky-details--frequency-collapsed .r-sticky-frequency {
            max-height: 0;
            padding-top: 0;
            padding-bottom: 0;
            opacity: 0;
          }
          .r-sticky-details--onetime .r-sf-label.r-sf-subs {
            display: none !important;
          }
          .r-sticky-details:not(.r-sticky-details--onetime) .r-sticky-selected-header .r-sf-label.r-sf-onetime-label {
            display: none !important;
          }
          .r-sf-subscribe-label, .r-sf-onetime-label {
            font-size: 14px;
          }
          
          .r-sticky-close {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 8.5px;
            right: 16px;
            cursor: pointer;
          }
          .r-sticky-badge {
            display: flex;
            padding: 2px 10px 6px 10px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: fit-content;
            position: absolute;
            left: 28px;
            top: 17px;
            border-radius: 8px;
            border: 4px solid #FFF;
            background: #173446;
            color: #FFF;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 100%;
          }
          .r-sf-item {
            padding: 16px 12px;
            border-radius: 6px;
            border: 1px solid rgba(17, 19, 20, 0.32);
          }
          .r-sf-active {
            border: 1.5px solid #111314;
          }
          .r-sticky-value-prop {
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
          }
          .r-sticky-value-prop-container {
            display: none;
            justify-content: space-between;
            align-items: flex-end;
            padding-top: 10px;
            border-top: 1px solid rgba(103, 103, 103, 0.32);
          }
          .r-sf-item.r-sf-subscription {
            gap: 18px;
          }
           .r-svp-text {
            font-weight: 400;
          }
          .r-svp-item:first-child .r-svp-text {
            font-weight: 700;
          }
          .r-sf-header {
            width: 100%;
          }
          .r-sf-onetime .r-sp-original {
            margin-left: auto;
            color: #111314;
          }
          .r-sf-subscription .r-sticky-prices {
            margin: 0 0 0 auto;
            display: flex;
            flex-direction: column-reverse;
            align-items: flex-end;
            gap: 6px;
          }
        }
        @supports (-webkit-touch-callout: none) {
          @media screen and (max-width: 768px) {
            /* iOS-specific styles */
          }
        }

        /* Smooth image transition when variant changes */
        .sb-sticky-atc__image {
          transition: opacity 0.2s ease;
        }
        .sb-sticky-atc__image.r-img-loading {
          opacity: 0.4;
        }
      `;
      utils.injectStyle(CONFIG.TEST_ID, css);
    },

    bindStickySync() {
      if (this._stickySyncBound) return;
      this._stickySyncBound = true;
      document.addEventListener('click', (e) => {
        const onetime = e.target.closest('.r-sf-onetime');
        const subscription = e.target.closest('.r-sf-subscription');
        if (!onetime && !subscription) return;
        const ctx = utils.getSubscriptionContext();
        if (!ctx) return;
        ctx.syncStickyChoiceToMain(!!onetime, !!subscription);
      });
      document.addEventListener('change', (e) => {
        const stickySelect = e.target.closest('.r-sticky-details .r-sf-select select');
        if (!stickySelect) return;
        const ctx = utils.getSubscriptionContext();
        if (!ctx) return;
        const mainSel = ctx.getMainFrequencySelect();
        if (!mainSel || mainSel.value === stickySelect.value) return;
        mainSel.value = stickySelect.value;
        mainSel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.addEventListener('click', (e) => {
        if (e.target.closest('.r-sticky-selected-btn') || e.target.closest('.r-sticky-close')) {
          const details = e.target.closest('.r-sticky-details');
          if (details) details.classList.toggle('r-sticky-details--frequency-collapsed');
        }
      });
    },

    main() {
      const pathname = window.location.pathname;
      if (this._productDataUrl && this._productDataUrl !== pathname) {
        this._productData = null;
        this._productDataUrl = null;
      }
      const ctx = utils.getSubscriptionContext();
      if (!ctx) return;
      const skioDropdown = ctx.getMainFrequencySelect();
      if (skioDropdown && !skioDropdown._rStickySyncAttached) {
        skioDropdown._rStickySyncAttached = true;
        skioDropdown.addEventListener('change', () => {
          const details = utils.q('.sb-sticky-atc__details');
          if (!details) return;
          const content = details.closest('.sb-sticky-atc__content');
          const stickyDetailsContainer = utils.isMobile() ? (content && content.parentNode) : details.parentNode;
          const stickyDetails = stickyDetailsContainer && utils.q('.r-sticky-details', stickyDetailsContainer);
          if (stickyDetails) utils.syncStickyFrequencySelects(stickyDetails, skioDropdown);
        });
      }
      const oneTime = ctx.getOneTime();
      if (this._stickyFetchPending) return;
      const details = utils.q('.sb-sticky-atc__details');
      const sizeEl = utils.q('variant-selects input:checked');
      const flavorEl = utils.q('.sb-flavor-selected__text');
      if (!details) return;
      const sizeValue = sizeEl ? String(sizeEl.value).trim() : '';
      const flavorValue = flavorEl ? flavorEl.textContent.trim() : '';
      if (!sizeValue && !flavorValue) return;
      const existingPrices = utils.q('.r-sticky-prices', details);
      const selectionUnchanged =
        existingPrices &&
        this._lastStickySize === sizeValue &&
        this._lastStickyFlavor === flavorValue &&
        this._lastStickyOneTime === oneTime;
      if (selectionUnchanged) {
        const contentEarly = details.closest('.sb-sticky-atc__content');
        const stickyDetailsContainerEarly = utils.isMobile() ? (contentEarly && contentEarly.parentNode) : details.parentNode;
        const stickyDetailsEarly = stickyDetailsContainerEarly && utils.q('.r-sticky-details', stickyDetailsContainerEarly);
        const mainFreqEarly = ctx.getMainFrequencySelect();
        if (stickyDetailsEarly && mainFreqEarly) utils.syncStickyFrequencySelects(stickyDetailsEarly, mainFreqEarly);
        return;
      }

      const updatePricesFromData = (data) => {
        const variants = data.variants || [];
        const variant = utils.matchVariantForSticky(variants, sizeValue, flavorValue);
        const price = variant ? variant.price : data.price;
        const plan0 = variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0];
        const compareAtPrice = plan0 ? plan0.price : (variant ? variant.compare_at_price : data.compare_at_price);
        const priceFormatted = price != null ? '$' + (price / 100).toFixed(2) : '';
        const compareFormatted = compareAtPrice != null ? '$' + (compareAtPrice / 100).toFixed(2) : '';
        const saveAmount = compareFormatted ? Math.round(((price - compareAtPrice) / 100).toFixed(2)) : 0;
        const prev = utils.q('.r-sticky-prices', details);
        if (prev) prev.remove();
        utils.eh(details, 'beforeend', `<div class="r-sticky-prices">
            ${oneTime ?
              `<span class="r-sp-original">${priceFormatted}</span>` :
              `${compareFormatted ? `<span class="r-sp-original">${compareFormatted}</span>` : ''}
              <span class="r-sp-current">${priceFormatted}</span>`
            }
          </div>`);
        this._lastStickySize = sizeValue;
        this._lastStickyFlavor = flavorValue;
        this._lastStickyOneTime = oneTime;

        // ── Dynamic variant image ──────────────────────────────────────────────
        // Update the sticky image to reflect the currently selected size/variant.
        // variant.featured_image is populated per-variant in Shopify's product.js
        // when a distinct image is assigned to that variant in the admin.
        utils.updateStickyImage(variant);
        // ──────────────────────────────────────────────────────────────────────

        const content = details.closest('.sb-sticky-atc__content');
        const stickyDetailsContainer = utils.isMobile() ? (content && content.parentNode) : details.parentNode;
        const sticky = details.closest('sb-sticky-add-to-cart');
        const existingAll = sticky ? Array.from(utils.qs('.r-sticky-details', sticky)) : [];

        if (existingAll.length > 1) {
          existingAll.slice(1).forEach((el) => el.remove());
        }

        let stickyDetails = existingAll.length > 0 ? existingAll[0] : null;
        if (stickyDetails) {
          if (stickyDetailsContainer && stickyDetails.parentNode !== stickyDetailsContainer) {
            if (utils.isMobile() && content) {
              content.parentNode.insertBefore(stickyDetails, content);
            } else {
              stickyDetailsContainer.appendChild(stickyDetails);
            }
          }
          stickyDetails.classList.toggle('r-sticky-details--mobile', !!utils.isMobile());
          stickyDetails.classList.toggle('r-sticky-details--onetime', !!oneTime);
          const onetimeEl = utils.q('.r-sf-onetime', stickyDetails);
          const subEl = utils.q('.r-sf-subscription', stickyDetails);
          if (onetimeEl) onetimeEl.classList.toggle('r-sf-active', oneTime);
          if (subEl) subEl.classList.toggle('r-sf-active', !oneTime);
          const skioSelect = ctx.getMainFrequencySelect();
          utils.syncStickyFrequencySelects(stickyDetails, skioSelect);
        }

        const select = ctx.getMainFrequencySelect();
        if (details && existingAll.length === 0 && select) {
          const mobileClass = utils.isMobile() ? ' r-sticky-details--mobile r-sticky-details--frequency-collapsed' : '';
          const onetimeClass = oneTime ? ' r-sticky-details--onetime' : '';
          const stickyHtml = `<div class="r-sticky-details${mobileClass}${onetimeClass}">
            <div class="r-sticky-frequency">
              <div class="r-sf-item r-sf-onetime${oneTime ? ' r-sf-active' : ''}">
                <div class="r-sf-header">
                  <div class="r-sf-radio">
                    <div class="r-sf-radio-inner"></div>
                  </div>
                  <div class="r-sf-label">One-Time Purchase</div>
                  ${utils.isMobile() ? `<span class="r-sp-original">${priceFormatted}</span>` : ''}
                </div>
              </div>
              <div class="r-sf-item r-sf-subscription${!oneTime ? ' r-sf-active' : ''}">
                <div class="r-sf-container">
                  <div class="r-sf-header">
                    <div class="r-sf-radio">
                      <div class="r-sf-radio-inner"></div>
                    </div>
                    <div class="r-sf-label">Subscribe and <span class="r-sf-save">Save $${saveAmount}</span></div>
                    ${utils.isMobile() ? `${compareFormatted ? `<div class="r-sticky-prices">
                      <span class="r-sp-original">${compareFormatted}</span>` : ''}
                      <span class="r-sp-current">${priceFormatted}</span>
                    </div>` : ''}
                  </div>
                  ${utils.isMobile() ? `` : `<div class="r-sf-select">
                    ${select.outerHTML}
                  </div>`}
                </div>
                <div class="r-sticky-value-prop-container">
                  <div class="r-sticky-value-prop">
                    ${CONFIG.VP.map(vp => `<div class="r-svp-item">
                      <div class="r-svp-icon"><img src="${CONFIG.CHECK_URL}" alt="" width="32" height="32" /></div>
                      <div class="r-svp-text">${vp}</div>
                    </div>`).join('')}
                  </div>
                  ${utils.isMobile() ? `<div class="r-sf-select">
                    ${select.outerHTML}
                  </div>` : ''}
                </div>
              </div>
              <div class="r-sticky-value-prop-container r-sticky-value-prop--desktop">
                <div class="r-sticky-value-prop">
                  ${CONFIG.VP.map((vp) => `<div class="r-svp-item">
                    <div class="r-svp-icon r-svp-icon--check"><img src="${CONFIG.CHECK_URL}" alt="" width="32" height="32" /></div>
                    <div class="r-svp-icon r-svp-icon--cross"><img src="${CONFIG.CROSS_URL}" alt="" width="32" height="32" /></div>
                    <div class="r-svp-text">${vp}</div>
                  </div>`).join('')}
                </div>
              </div>
              ${utils.isMobile() ? `<div class="r-sticky-close">${CONFIG.CLOSE}</div>` : ''}
              ${utils.isMobile() ? `<div class="r-sticky-badge">Free Shipping</div>` : ''}
            </div>
            ${utils.isMobile() ? `<div class="r-sticky-selected">
              <div class="r-sticky-selected-header">
                <div class="r-sf-label r-sf-subs"><span class="r-sf-subscribe-label">Subscribe and</span> <span class="r-sf-save">Save $${saveAmount}</span> <span class="r-sf-free-shipping">+ Free Shipping</span></div>
                <div class="r-sf-label r-sf-onetime-label">One-Time Purchase</div>
              </div>
              <div class="r-sticky-selected-btn">
                <span class="r-sf-edit">Edit</span>
                <span class="r-sf-arrow">${CONFIG.ARROW}</span>
              </div>
            </div>` : ''}
          </div>`;
          if (utils.isMobile() && content) {
            utils.eh(content, 'beforebegin', stickyHtml);
          } else {
            utils.eh(details, 'afterend', stickyHtml);
          }
          const inserted = sticky && utils.q('.r-sticky-details', sticky);
          utils.syncStickyFrequencySelects(inserted, select);
        }
      };

      if (this._productData) {
        updatePricesFromData(this._productData);
        return;
      }

      this._stickyFetchPending = true;
      const url = pathname + '.js' + (window.location.search || '');
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error('Fetch failed: ' + res.status);
          return res.json();
        })
        .then((data) => {
          this._productData = data;
          this._productDataUrl = pathname;
          updatePricesFromData(data);
          return data;
        })
        .catch((err) => console.warn('Fetch failed:', err))
        .finally(() => { this._stickyFetchPending = false; });
    },

    observeMutations() {
      const observer = new MutationObserver(utils.debounce(() => {
        this.main();
      }, 30));

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true
      });

      this.observer = observer;
    },

    destroy() {
      if (this.observer) this.observer.disconnect();
      const styleEl = document.getElementById(CONFIG.TEST_ID);
      if (styleEl) styleEl.remove();
    }
  };

  // ==== Bootstrapping the Test ====
  utils.wait(CONFIG.SELECTORS.BODY, (body) => {
    try {
      log.start();   // Log bucket and test info
      body.classList.add(CONFIG.TEST_ID);
      test.init();   // Run test
      log.end();     // Log completion
    } catch (err) {
      log.fail(err); // Log any error
    }
  });
}();